import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "table-header-item-count" }
const _hoisted_2 = { class: "pr-3" }
const _hoisted_3 = { style: {"text-decoration":"underline"} }
const _hoisted_4 = { class: "pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TextHighlights = _resolveComponent("TextHighlights")!
  const _component_EditDokumentDialog = _resolveComponent("EditDokumentDialog")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_SingleFilter = _resolveComponent("SingleFilter")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_NowhowDatepicker = _resolveComponent("NowhowDatepicker")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_FilterDrawer = _resolveComponent("FilterDrawer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_infinite_scroll, { onLoad: _ctx.load }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    "sort-by": _ctx.sortBy,
                    "onUpdate:sortBy": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sortBy) = $event)),
                      _ctx.onSortByChanged
                    ],
                    modelValue: _ctx.selected,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selected) = $event)),
                    headers: _ctx.headers,
                    items: _ctx.dokumentList,
                    loading: _ctx.loading,
                    "items-length": _ctx.totalNumberOfRecords || 0,
                    "hide-default-footer": "",
                    class: "elevation-1",
                    "must-sort": true,
                    "custom-sort": _ctx.customSort,
                    "show-select": "",
                    hover: "",
                    "return-object": ""
                  }, {
                    top: _withCtx(() => [
                      (_ctx.selected.length < 1)
                        ? (_openBlock(), _createBlock(_component_TableHeader, {
                            key: 0,
                            filters: _ctx.filters,
                            onChipClosed: _ctx.removeFilter
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.totalNumberOfRecords + ' ' + _ctx.$t('archiv.table.header.items')), 1),
                              (_ctx.showSearchBar)
                                ? (_openBlock(), _createBlock(_component_v_text_field, {
                                    key: 0,
                                    modelValue: _ctx.filterData.bezeichnung,
                                    "onUpdate:modelValue": [
                                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.bezeichnung) = $event)),
                                      _ctx.searchFieldInputChanged
                                    ],
                                    class: "ml-5",
                                    "prepend-inner-icon": "mdi-magnify",
                                    "append-icon": "mdi-close",
                                    label: _ctx.$t('archiv.table.header.searchlabel'),
                                    "hide-details": "",
                                    autofocus: "",
                                    "onClick:append": _ctx.searchBarClosed
                                  }, null, 8, ["modelValue", "label", "onUpdate:modelValue", "onClick:append"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_tooltip, {
                                top: "",
                                color: "secondary"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps(props, {
                                    icon: "",
                                    color: "primary"
                                  }), {
                                    default: _withCtx(() => [
                                      (!_ctx.showSearchBar)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchBar = !_ctx.showSearchBar))
                                          }, {
                                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                                              _createTextVNode("mdi-magnify")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.search')), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_tooltip, {
                                top: "",
                                color: "secondary"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps(props, {
                                    icon: "",
                                    color: "primary",
                                    onClick: _ctx.downloadAllDokumenteWithFilter
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                                          _createTextVNode("mdi-download")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1040, ["onClick"])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.download')), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_tooltip, {
                                top: "",
                                color: "secondary"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps(props, {
                                    icon: "",
                                    color: "primary",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterDrawer = !_ctx.showFilterDrawer))
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                                          _createTextVNode("mdi-filter-outline")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.filter')), 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["filters", "onChipClosed"]))
                        : (_openBlock(), _createBlock(_component_TableHeader, {
                            key: 1,
                            filters: _ctx.filters,
                            "download-toolbar": true,
                            onChipClosed: _ctx.removeFilter
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(_ctx.selected.length + ' ' + _ctx.$t('archiv.table.header.items') + ' (total ' + _ctx.maximumFileSize + ')'), 1),
                              _createVNode(_component_v_spacer),
                              _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("a", {
                                  style: {"color":"white"},
                                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloadMultipleDokumenteWrapper && _ctx.downloadMultipleDokumenteWrapper(...args)))
                                }, [
                                  _cache[22] || (_cache[22] = _createTextVNode(" Download")),
                                  _createVNode(_component_v_icon, { color: "white" }, {
                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                      _createTextVNode("mdi-download")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _cache[23] || (_cache[23] = _createElementVNode("span", {
                                  class: "pl-1 pr-1",
                                  style: {"font-size":"20px"}
                                }, "|", -1)),
                                _createElementVNode("a", {
                                  style: {"color":"white"},
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selected = []))
                                }, " Cancel ")
                              ])
                            ]),
                            _: 1
                          }, 8, ["filters", "onChipClosed"]))
                    ]),
                    "item.bezeichnung": _withCtx(({ item }) => [
                      _createElementVNode("a", _hoisted_3, [
                        _createVNode(_component_TextHighlights, {
                          text: item.bezeichnung,
                          "search-text": _ctx.filterData.bezeichnung,
                          onClick: ($event: any) => (
                                        _ctx.openDokument({
                                            id: item.dokumentGuid,
                                            dateiTyp: item.mimeTyp,
                                            dokumentName: item.bezeichnung
                                        })
                                    )
                        }, null, 8, ["text", "search-text", "onClick"])
                      ])
                    ]),
                    "item.schlagworte": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.schlagworte,
                        "search-text": _ctx.filterData.bezeichnung
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.dokumentTypCode": _withCtx(({ item }) => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.dokumentTypCode)), 1)
                    ]),
                    "item.link": _withCtx(({ item }) => [
                      _createVNode(_component_v_btn, {
                        icon: "",
                        class: "elevation-0",
                        href: item.link,
                        onClick: ($event: any) => (
                                    _ctx.downloadDokument({
                                        id: item.dokumentGuid,
                                        dokumentName: item.bezeichnung
                                    })
                                )
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            icon: "mdi-download-outline"
                          })
                        ]),
                        _: 2
                      }, 1032, ["href", "onClick"])
                    ]),
                    "item.burgermenu": _withCtx(({ item }) => [
                      (_ctx.hasAccess('Archiv.EigeneDokumente.Schreiben'))
                        ? (_openBlock(), _createBlock(_component_v_menu, {
                            key: 0,
                            modelValue: item.burgermenuActive,
                            "onUpdate:modelValue": ($event: any) => ((item.burgermenuActive) = $event),
                            "offset-x": ""
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps({
                                icon: "",
                                href: item.burgermenu
                              }, props, { class: "elevation-0" }), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: "primary",
                                    icon: "mdi-menu"
                                  })
                                ]),
                                _: 2
                              }, 1040, ["href"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_EditDokumentDialog, {
                                    "dokument-id": item.dokumentID,
                                    "full-dokument-name": item.dateiName + '.' + item.dateiErweiterung,
                                    "dokument-typ": item.dokumentTypCode
                                  }, null, 8, ["dokument-id", "full-dokument-name", "dokument-typ"]),
                                  (item.dokumentTypCode == 'archiv.dokumenttyp.eigenesdok')
                                    ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
                                        key: 0,
                                        title: "archiv.deletedialog.title",
                                        text: "archiv.deletedialog.text",
                                        onConfirm: ($event: any) => (_ctx.deleteDokumentWrapper(item.dokumentID))
                                      }, {
                                        activatorElement: _withCtx(({ props }) => [
                                          _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, {
                                                textContent: _toDisplayString(_ctx.$t('archiv.table.burgermenu.delete'))
                                              }, null, 8, ["textContent"])
                                            ]),
                                            _: 2
                                          }, 1040)
                                        ]),
                                        _: 2
                                      }, 1032, ["onConfirm"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_list_item, {
                                    onClick: ($event: any) => (
                                            _ctx.downloadDokument({
                                                id: item.dokumentGuid,
                                                dokumentName: item.bezeichnung
                                            })
                                        )
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, {
                                        textContent: _toDisplayString(_ctx.$t('archiv.table.burgermenu.download'))
                                      }, null, 8, ["textContent"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"]))
                        : (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            icon: "",
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "grey",
                                icon: "mdi-menu"
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["sort-by", "modelValue", "headers", "items", "loading", "items-length", "custom-sort", "onUpdate:sortBy"])
                ]),
                _: 1
              }, 8, ["onLoad"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FilterDrawer, {
        visible: _ctx.showFilterDrawer,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showFilterDrawer) = $event)),
        onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.cancelFilter())),
        onConfirm: _cache[15] || (_cache[15] = ($event: any) => (_ctx.confirmFilter())),
        onClear: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearFilters(true))),
        onReset: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearFilters(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SingleFilter, {
            title: _ctx.$t('archiv.table.header.dokumenttyp')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filterData.dokumentTyp,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterData.dokumentTyp) = $event)),
                        variant: "filled",
                        density: "compact",
                        "hide-details": "",
                        items: _ctx.dokumentTypes
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_SingleFilter, {
            title: _ctx.$t('archiv.table.header.filetyp')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { scols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filterData.fileTyp,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterData.fileTyp) = $event)),
                        variant: "filled",
                        density: "compact",
                        "hide-details": "",
                        items: _ctx.fileTypes
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_SingleFilter, {
            title: _ctx.$t('archiv.table.header.erstelltvon')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filterData.erstelltVon,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterData.erstelltVon) = $event)),
                        variant: "filled",
                        density: "compact",
                        "hide-details": "",
                        items: _ctx.erstelltVon
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_SingleFilter, {
            title: "",
            class: "py-0 mt-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio_group, {
                modelValue: _ctx.radios,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.radios) = $event)),
                class: "pb-0 filterLine",
                inline: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('archiv.filter.title.datum')), 1),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        value: "selectTime",
                        label: _ctx.$t('archiv.filter.datum.radio.selecttime')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        value: "allTime",
                        label: _ctx.$t('archiv.filter.datum.radio.alltime')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        value: "specificTime",
                        label: _ctx.$t('archiv.filter.datum.radio.specifictime')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pb-0 pt-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: "pb-0",
                            cols: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_NowhowDatepicker, {
                                modelValue: _ctx.filterData.dateFrom,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filterData.dateFrom) = $event)),
                                disabled: _ctx.radios !== 'specificTime',
                                label: "archiv.filter.datum.von"
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            class: "pb-0",
                            cols: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_NowhowDatepicker, {
                                modelValue: _ctx.filterData.dateTo,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filterData.dateTo) = $event)),
                                disabled: _ctx.radios !== 'specificTime',
                                label: "archiv.filter.datum.bis"
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}